const routes = [
  {
    path: '/notifications',
    component: () => import(/* webpackChunkName: "Notifications" */ './components/notificationPane/NotificationPane.vue'),
    meta: { pageNameEn: 'Notifications' },
  },
];
export default routes;
